import { render, staticRenderFns } from "./NoticeTable.vue?vue&type=template&id=29f3fd74&scoped=true&"
import script from "./NoticeTable.vue?vue&type=script&lang=js&"
export * from "./NoticeTable.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTable.vue?vue&type=style&index=0&id=29f3fd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3fd74",
  null
  
)

export default component.exports